<!-- <app-product-compare></app-product-compare> -->
<app-compare-product></app-compare-product>
<!-- <div class="popular-compare">
    <div class="container">
        <h1 class="page-sub-title cv-text-dark mb-4 mt-4">Popular Comparison</h1>
        <div class="row">
            <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4">
                <div class="card">
                    <div class="card-body">
                        <div class="box">
                            <div class="item">
                                <img [src]='environment1 + "assets/images/prod-img.png"' class="img-fluid" loading="lazy"/>
                                <div class="content">
                                    <h5>Ace Gold CNG Plus</h5>
                                    <div class="price">8,45,000 <span>Ex-showroom</span>
                                    </div>
                                </div>

                            </div>
                            <div class="item">
                                <img [src]='environment1 + "assets/images/prod-img.png"' class="img-fluid" loading="lazy"/>
                                <div class="content">
                                    <h5>Ace Gold CNG Plus</h5>
                                    <div class="price">8,45,000 <span>Ex-showroom</span>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="d-grid mt-3">
                            <button type="button" class="btn btn-outline-primary">Compare Now</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4">
                <div class="card">
                    <div class="card-body">
                        <div class="box">
                            <div class="item">
                                <img [src]='environment1 + "assets/images/prod-img.png"' class="img-fluid" loading="lazy"/>
                                <div class="content">
                                    <h5>Ace Gold CNG Plus</h5>
                                    <div class="price">8,45,000 <span>Ex-showroom</span>
                                    </div>
                                </div>

                            </div>
                            <div class="item">
                                <img [src]='environment1 + "assets/images/prod-img.png"' class="img-fluid" loading="lazy"/>
                                <div class="content">
                                    <h5>Ace Gold CNG Plus</h5>
                                    <div class="price">8,45,000 <span>Ex-showroom</span>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="d-grid mt-3">
                            <button type="button" class="btn btn-outline-primary">Compare Now</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4">
                <div class="card">
                    <div class="card-body">
                        <div class="box">
                            <div class="item">
                                <img [src]='environment1 + "assets/images/prod-img.png"' class="img-fluid" loading="lazy"/>
                                <div class="content">
                                    <h5>Ace Gold CNG Plus</h5>
                                    <div class="price">8,45,000 <span>Ex-showroom</span>
                                    </div>
                                </div>

                            </div>
                            <div class="item">
                                <img [src]='environment1 + "assets/images/prod-img.png"' class="img-fluid" loading="lazy"/>
                                <div class="content">
                                    <h5>Ace Gold CNG Plus</h5>
                                    <div class="price">8,45,000 <span>Ex-showroom</span>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="d-grid mt-3">
                            <button type="button" class="btn btn-outline-primary">Compare Now</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
 -->
